module.exports = __webpack_public_path__ + "img/mryl_banner.e239c37e.png";